import iconAvatar from 'assets/img/user/img/icon-avatar.svg';
import iconGoogle from 'assets/img/user/img/icon-google.svg';
import iconFacebook from 'assets/img/user/img/icon-facebook.svg';
import iconCamera from 'assets/img/user/img/icon-camera.svg';
import iconPicture from 'assets/img/user/img/icon-picture.svg';

export const images = {
    avatar: iconAvatar,
    google: iconGoogle,
    facebook: iconFacebook,
    camera: iconCamera,
    picture: iconPicture
};